import { render } from "./ResidentItem.vue?vue&type=template&id=1c9ba926&ts=true"
import script from "./ResidentItem.ts?vue&type=script&lang=ts"
export * from "./ResidentItem.ts?vue&type=script&lang=ts"

import "./ResidentItem.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__